export const LOGIN_RESET = 'LOGIN_RESET';
export const LOGIN_USER_REQUEST = 'LOGIN_USER_REQUEST';
export const LOGIN_USER_FAILURE = 'LOGIN_USER_FAILURE';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const LOGIN_CHECKUP = 'LOGIN_CHECKUP';
export const LOGOUT_USER = 'LOGOUT_USER';
export const UPDATE_STATUS_TEXT = 'UPDATE_STATUS_TEXT';
export const REDIRECT_TO_RESET_PASSWORD = 'REDIRECT_TO_RESET_PASSWORD';
export const EMAIL_REGISTRATION_TOKEN_VALIDATED = 'EMAIL_REGISTRATION_TOKEN_VALIDATED';

export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_REQUEST_FAILURE = 'LOGIN_REQUEST_FAILURE';

export const LOGIN_OTP_TYPE_RESET = 'LOGIN_OTP_TYPE_RESET';
export const OTP_TYPE_LOGIN_REQUEST = 'OTP_TYPE_LOGIN_REQUEST';
export const OTP_TYPE_LOGIN_REQUEST_SUCCESS = 'OTP_TYPE_LOGIN_REQUEST_SUCCESS';
export const OTP_TYPE_LOGIN_REQUEST_FAILURE = 'OTP_TYPE_LOGIN_REQUEST_FAILURE';

export const VERIFY_OTP_LOGIN_REQUEST = 'VERIFY_OTP_LOGIN_REQUEST';
export const VERIFY_OTP_LOGIN_REQUEST_SUCCESS = 'VERIFY_OTP_LOGIN_REQUEST_SUCCESS';
export const VERIFY_OTP_LOGIN_REQUEST_FAILURE = 'VERIFY_OTP_LOGIN_REQUEST_FAILURE';

export const LOGIN_OTP_FOCUS_AFTER_FAIL = 'LOGIN_OTP_FOCUS_AFTER_FAIL';




// WEBPACK FOOTER //
// ./src/constants/authConstants.js